import React, { useState } from 'react';
import Modal from '../common/Modal';
import FormField from '../common/FormField';
import { superAdminApi } from '../../services/superAdminApi';

const CreateTenantModal = ({ onClose, onTenantCreated }) => {
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    email: '',
    phone: '',
    status: 'active'
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Auto-generate slug from name
    if (field === 'name') {
      const slug = value.toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim();
      setFormData(prev => ({
        ...prev,
        slug: slug
      }));
    }

    // Clear errors when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: null
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      const response = await superAdminApi.createTenant(formData);
      onTenantCreated && onTenantCreated();
      onClose();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors || {});
      } else {
        setErrors({
          general: error.response?.data?.message || 'Failed to create tenant'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal onClose={onClose} title="Create New Tenant" size="medium">
      <form onSubmit={handleSubmit} className="create-tenant-form">
        {errors.general && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            {errors.general}
          </div>
        )}

        <FormField
          label="Organization Name"
          type="text"
          value={formData.name}
          onChange={(value) => handleChange('name', value)}
          placeholder="e.g., Mumbai Cricket Association"
          error={errors.name?.[0]}
          required
          fullWidth
        />

        <FormField
          label="Slug (URL identifier)"
          type="text"
          value={formData.slug}
          onChange={(value) => handleChange('slug', value)}
          placeholder="e.g., mumbai-cricket"
          error={errors.slug?.[0]}
          required
          fullWidth
          helpText="This will be used for subdomains (e.g., mumbai-cricket.abfisaas.local)"
        />

        <FormField
          label="Admin Email"
          type="email"
          value={formData.email}
          onChange={(value) => handleChange('email', value)}
          placeholder="admin@organization.com"
          error={errors.email?.[0]}
          required
          fullWidth
        />

        <FormField
          label="Phone Number"
          type="tel"
          value={formData.phone}
          onChange={(value) => handleChange('phone', value)}
          placeholder="+91 12345 67890"
          error={errors.phone?.[0]}
          fullWidth
        />

        <div className="form-actions">
          <button
            type="button"
            onClick={onClose}
            className="btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Creating...
              </>
            ) : (
              <>
                <i className="fas fa-plus"></i>
                Create Tenant
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateTenantModal;